function Wordmark({ size = 32, light = false }) {
  const c1 = light ? '#FFFFFF' : 'var(--accent)';
  const c2 = light ? 'rgba(255,255,255,0.55)' : 'var(--accent-cyan)';
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
      <rect x="4"  y="6"  width="32" height="10" rx="5" fill={c1} opacity="0.95"/>
      <rect x="4"  y="15" width="32" height="10" rx="5" fill={c2} opacity="0.7"/>
      <rect x="4"  y="24" width="32" height="10" rx="5" fill={c1} opacity="0.95"/>
    </svg>
  );
}

export default Wordmark;
